import { getBorderFocusStyles } from '../../getBorderFocusStyles';
import { treeTitleClassName, treeTitleSlotClassNames } from '../../../../components/Tree/TreeTitle';
export var treeItemStyles = {
  root: function root(_ref) {
    var _ref2, _ref3, _Object$assign;

    var siteVariables = _ref.theme.siteVariables,
        p = _ref.props;
    var borderFocusStyles = getBorderFocusStyles({
      variables: siteVariables
    });
    return {
      listStyleType: 'none',
      ':focus': Object.assign({}, p.selectable && (_ref2 = {}, _ref2["& ." + treeTitleSlotClassNames.indicator] = {
        display: 'inline-block'
      }, _ref2), borderFocusStyles[':focus']),
      ':focus-visible': Object.assign({
        outline: 0
      }, p.selectable && (_ref3 = {}, _ref3["& ." + treeTitleSlotClassNames.indicator] = {
        display: 'inline-block'
      }, _ref3), (_Object$assign = {}, _Object$assign["> ." + treeTitleClassName] = Object.assign({
        position: 'relative'
      }, borderFocusStyles[':focus-visible']), _Object$assign))
    };
  }
};
//# sourceMappingURL=treeItemStyles.js.map
